import { MailProvider } from "@/types/installedintegration";

export interface EmailComposeParams {
  provider: MailProvider;
  to: string[];
  cc: string[];
  subject: string;
  body: string;
}

export const providerLabel = (provider: MailProvider): string =>
  provider === "google" ? "Gmail" : "Outlook";

export const buildComposeUrl = ({
  provider,
  to,
  cc,
  subject,
  body,
}: EmailComposeParams): string => {
  const primary = to[0] ?? "";
  const ccJoined = cc.join(",");

  if (provider === "google") {
    return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(primary)}&cc=${encodeURIComponent(ccJoined)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  const outlookTo = ccJoined ? `${primary},${ccJoined}` : primary;
  return `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(outlookTo)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const openComposeUrl = (params: EmailComposeParams): void => {
  window.open(buildComposeUrl(params), "_blank");
};
